import { Component, Output, EventEmitter, ViewChild, ElementRef, OnInit } from '@angular/core';
import { ScrollService } from '../../services/scroll.service';

@Component({
  selector: 'app-welcome-banner-section',
  templateUrl: './welcome-banner-section.component.html',
  styleUrls: ['./welcome-banner-section.component.scss'],
  standalone: false,
})
export class WelcomeBannerSectionComponent implements OnInit {
  @ViewChild('packageSection') packageSection: ElementRef;
  @Output() moveToSectionEvent: EventEmitter<void> = new EventEmitter<void>();

  constructor(
    private elRef: ElementRef,
    private scrollService: ScrollService
  ){

  }

  ngOnInit(): void {
    
  }

  moveToSection() {
    this.moveToSectionEvent.emit();
  }

  scrollToPackageSection() {
    this.scrollService.triggerScrollToPackageSection();
  }
}
